$("body").on("click", ".choiceIconContainer", function () {
  let selections = getIntiaroPlayer("hmc360-viewer").getParams();
  console.log(selections);
  $("#product-sku").text(generateSku(selections));
});

$(document).ready(function () {
  setTimeout(function () {
    let selections = getIntiaroPlayer("hmc360-viewer").getParams();
    $("#product-sku").text(generateSku(selections));
  }, 1000);
});

function generateSku(selections) {
  const finishMap = {
    hm_finish_antique_vanilla: "av",
    hm_finish_antique_black: "ab",
    hm_finish_espresso: "es",
    hm_finish_newport: "nc",
    hm_finish_saratoga: "sc",
    hm_finish_weathered: "k1",
    hm_finish_camden_oak: "ca",
    hm_finish_ivory_oak: "vk",
    hm_finish_oyster_gray_oak: "oy",
    hm_finish_black_oak: "l2",
    hm_finish_dark_coffee_oak: "l4",
    hm_finish_m1: "m2", //Ivory
    hm_finish_light_oak: "l5",
  };

  const topMap = {
    hm_0324_top_cove: "c",
    hm_0324_top_slab: "s",
  };

  const baseMap = {
    hm_0324_base_traditional: "1",
    hm_0324_base_transitional: "2",
    hm_0324_base_contemporary: "3",
  };

  const topDoorStyleMap = {
    hm_0324_top_dor_opt_1_plain_glass: "1",
    hm_0324_top_dor_opt_2_beveled_glass: "2",
    hm_0324_top_dor_opt_3_glass_pane: "3",
    hm_0324_top_dor_opt_4_beveled_panel: "4",
    hm_0324_top_dor_opt_5_inset_panel: "5",
    hm_0324_top_dor_opt_6_glass_pane_ii: "6",
    hm_0324_top_dor_opt_7_flat_panel: "7",
    hm_0324_top_dor_opt_r_reeded_glasss: "r",
    hm_0324_top_dor_opt_g_glass_pane_iii: "g",
    hm_0324_top_dor_opt_p_glass_pane_iv: "p",
    hm_0324_top_dor_opt_x_glass_pane_v: "x",
  };

  const topDoorHardwareMap = {
    hm_0324_top_dor_hdw_a_nickel_knob: "a",
    hm_0324_top_dor_hdw_b_nickel_bar: "b",
    hm_0324_top_dor_hdw_c_nickel_elegant_pull: "c",
    hm_0324_top_dor_hdw_d_brass_knob: "d",
    hm_0324_top_dor_hdw_e_brass_bar: "e",
    hm_0324_top_dor_hdw_f_brass_elegant_pull: "f",
    hm_0324_top_dor_hdw_g_iron_knob: "g",
    hm_0324_top_dor_hdw_h_iron_bar: "h",
    hm_0324_top_dor_hdw_j_iron_elegant_pull: "j",
    hm_0324_top_dor_hdw_w_interior_magnetic_push_release: "w",
  };

  const middleDoorStyleMap = {
    hm_0324_middle_dor_opt_1_plain_glass: "1",
    hm_0324_middle_dor_opt_2_beveled_glass: "2",
    hm_0324_middle_dor_opt_3_glass_pane: "3",
    hm_0324_middle_dor_opt_4_beveled_panel: "4",
    hm_0324_middle_dor_opt_5_inset_panel: "5",
    hm_0324_middle_dor_opt_6_glass_pane_ii: "6",
    hm_0324_middle_dor_opt_7_flat_panel: "7",
    hm_0324_middle_dor_opt_r_reeded_glasss: "r",
    hm_0324_middle_dor_opt_g_glass_pane_iii: "g",
    hm_0324_middle_dor_opt_p_glass_pane_iv: "p",
    hm_0324_middle_dor_opt_x_glass_pane_v: "x",
  };

  const middleDoorHardwareMap = {
    hm_0324_middle_dor_hdw_a_nickel_knob: "a",
    hm_0324_middle_dor_hdw_b_nickel_bar: "b",
    hm_0324_middle_dor_hdw_c_nickel_elegant_pull: "c",
    hm_0324_middle_dor_hdw_d_brass_knob: "d",
    hm_0324_middle_dor_hdw_e_brass_bar: "e",
    hm_0324_middle_dor_hdw_f_brass_elegant_pull: "f",
    hm_0324_middle_dor_hdw_g_iron_knob: "g",
    hm_0324_middle_dor_hdw_h_iron_bar: "h",
    hm_0324_middle_dor_hdw_j_iron_elegant_pull: "j",
    hm_0324_middle_dor_hdw_w_interior_magnetic_push_release: "w",
  };

  const bottomDoorStyleMap = {
    hm_0324_bottom_dor_opt_1_plain_glass: "1",
    hm_0324_bottom_dor_opt_2_beveled_glass: "2",
    hm_0324_bottom_dor_opt_3_glass_pane: "3",
    hm_0324_bottom_dor_opt_4_beveled_panel: "4",
    hm_0324_bottom_dor_opt_5_inset_panel: "5",
    hm_0324_bottom_dor_opt_6_glass_pane_ii: "6",
    hm_0324_bottom_dor_opt_7_flat_panel: "7",
    hm_0324_bottom_dor_opt_r_reeded_glasss: "r",
    hm_0324_bottom_dor_opt_g_glass_pane_iii: "g",
    hm_0324_bottom_dor_opt_p_glass_pane_iv: "p",
    hm_0324_bottom_dor_opt_x_glass_pane_v: "x",
  };

  const bottomDoorHardwareMap = {
    hm_0324_bottom_dor_hdw_a_nickel_knob: "a",
    hm_0324_bottom_dor_hdw_b_nickel_bar: "b",
    hm_0324_bottom_dor_hdw_c_nickel_elegant_pull: "c",
    hm_0324_bottom_dor_hdw_d_brass_knob: "d",
    hm_0324_bottom_dor_hdw_e_brass_bar: "e",
    hm_0324_bottom_dor_hdw_f_brass_elegant_pull: "f",
    hm_0324_bottom_dor_hdw_g_iron_knob: "g",
    hm_0324_bottom_dor_hdw_h_iron_bar: "h",
    hm_0324_bottom_dor_hdw_j_iron_elegant_pull: "j",
    hm_0324_bottom_dor_hdw_w_interior_magnetic_push_release: "w",
  };
  /*
  const middleDrawerStyleMap = {
    hm_0324_middle_drawer_opt_1_flat_panel: "8",
    hm_0324_middle_drawer_opt_1_inset_panel: "9",
  };

  const middleDrawerHardwareMap = {
    hm_0324_middle_drawer_hdw_a_nickel_knob: "a",
    hm_0324_middle_drawer_hdw_b_nickel_bar: "b",
    hm_0324_middle_drawer_hdw_c_nickel_elegant_pull: "c",
    hm_0324_middle_drawer_hdw_d_brass_knob: "d",
    hm_0324_middle_drawer_hdw_e_brass_bar: "e",
    hm_0324_middle_drawer_hdw_f_brass_elegant_pull: "f",
    hm_0324_middle_drawer_hdw_g_iron_knob: "g",
    hm_0324_middle_drawer_hdw_h_iron_bar: "h",
    hm_0324_middle_drawer_hdw_j_iron_elegant_pull: "j",
    hm_0324_middle_drawer_hdw_w_interior_magnetic_push_release: "w",
  };
*/
  const drawerStyleMap = {
    hm_0324_drawer_opt_8_flat_panel: "8",
    hm_0324_drawer_opt_9_inset_panel: "9",
  };

  const drawerHardwareMap = {
    hm_0324_drawer_hdw_a_nickel_knob: "a",
    hm_0324_drawer_hdw_b_nickel_bar: "b",
    hm_0324_drawer_hdw_c_nickel_elegant_pull: "c",
    hm_0324_drawer_hdw_d_brass_knob: "d",
    hm_0324_drawer_hdw_e_brass_bar: "e",
    hm_0324_drawer_hdw_f_brass_elegant_pull: "f",
    hm_0324_drawer_hdw_g_iron_knob: "g",
    hm_0324_drawer_hdw_h_iron_bar: "h",
    hm_0324_drawer_hdw_j_iron_elegant_pull: "j",
    hm_0324_drawer_hdw_w_interior_magnetic_push_release: "w",
  };

  const dimMap = {
    H1G: { height: 61.812, width: 25.25, depth: 17.5 },
    H2J: { height: 61.812, width: 46.25, depth: 17.5 },
    H2D: { height: 43.781, width: 46.25, depth: 17.5 },
    H3G: { height: 61.812, width: 67.25, depth: 17.5 },
    H3J: { height: 61.812, width: 67.25, depth: 17.5 },
    H2H: { height: 61.812, width: 46.25, depth: 17.5 },
    H3F: { height: 61.812, width: 67.25, depth: 17.5 },
    H3B: { height: 43.781, width: 67.25, depth: 17.5 },
    H1F: { height: 61.812, width: 25.25, depth: 17.5 },
    H1A: { height: 43.781, width: 25.25, depth: 17.5 },
    H3E: { height: 43.781, width: 67.25, depth: 17.5 },
    H1E: { height: 61.812, width: 25.25, depth: 17.5 },
    H2E: { height: 43.781, width: 46.25, depth: 17.5 },
    H3D: { height: 43.781, width: 67.25, depth: 17.5 },
    H2G: { height: 61.812, width: 46.25, depth: 17.5 },
    H1C: { height: 61.812, width: 25.25, depth: 17.5 },
    H2C: { height: 43.781, width: 46.25, depth: 17.5 },
    H2A: { height: 43.781, width: 46.25, depth: 17.5 },
    H3C: { height: 43.781, width: 67.25, depth: 17.5 },
    H3H: { height: 61.812, width: 67.25, depth: 17.5 },
    H3A: { height: 43.781, width: 67.25, depth: 17.5 },
    H1B: { height: 43.781, width: 25.25, depth: 17.5 },
    H1D: { height: 61.812, width: 25.25, depth: 17.5 },
    H2B: { height: 43.781, width: 46.25, depth: 17.5 },
    H2F: { height: 61.812, width: 46.25, depth: 17.5 }
  };

  const handleMap = {
    H1G: "22-25-storage-cabinet",
    H2J: "43-46-extra-tall-storage-cabinet",
    H2D: "43-46-storage-cabinet",
    H3G: "64-67-extra-tall-storage-cabinet",
    H3J: "64-67-extra-tall-storage-cabinet-1",
    H2H: "43-46-extra-tall-storage-cabinet-1",
    H3F: "64-67-extra-tall-storage-cabinet-2",
    H3B: "64-67-storage-cabinet",
    H1F: "22-25-storage-cabinet-1",
    H1A: "22-25-storage-cabinet-2",
    H3E: "64-67-storage-cabinet-1",
    H1E: "22-25-storage-cabinet-3",
    H2E: "43-46-storage-cabinet-1",
    H3D: "64-67-storage-cabinet-2",
    H2G: "43-46-extra-tall-storage-cabinet-2",
    H1C: "22-25-storage-cabinet-4",
    H2C: "43-46-storage-cabinet-2",
    H2A: "43-46-storage-cabinet-3",
    H3C: "64-67-storage-cabinet-3",
    H3H: "64-67-extra-tall-storage-cabinet-3",
    H3A: "64-67-storage-cabinet-4",
    H1B: "22-25-storage-cabinet-5",
    H1D: "22-25-storage-cabinet-6",
    H2B: "43-46-storage-cabinet-4",
    H2F: "43-46-extra-tall-storage-cabinet-3"
};

  const hValue = selections.hm_0324_pick_a_style.slice(-3).substring(0, 2) || "-";
  const styleCode = selections.hm_0324_pick_a_style.slice(-1) || "-";
  const finishCode = finishMap[selections.hm_pick_a_wood_finish] || "-";
  const topCode = topMap[selections.hm_0324_top] || "-";
  const baseCode = baseMap[selections.hm_0324_base] || "-";
  const topDoorStyleCode = topDoorStyleMap[selections.hm_0324_top_door_options] || "-";
  const topDoorHardwareCode = topDoorHardwareMap[selections.hm_0324_top_door_hardware] || "-";
  const middleDoorStyleCode = middleDoorStyleMap[selections.hm_0324_middle_door_options] || "-";
  const middleDoorHardwareCode = middleDoorHardwareMap[selections.hm_0324_middle_door_hardware] || "-";
  const bottomDoorStyleCode = bottomDoorStyleMap[selections.hm_0324_bottom_door_options] || "-";
  const bottomDoorHardwareCode = bottomDoorHardwareMap[selections.hm_0324_bottom_door_hardware] || "-";
  const drawerStyleCode = drawerStyleMap[selections.hm_0324_drawer_option] || "-";
  const drawerHardwareCode = drawerHardwareMap[selections.hm_0324_drawer_hardware] || "-";

  const sku =
    hValue +
    styleCode +
    finishCode +
    topCode +
    baseCode +
    (hasTopDoors(hValue, styleCode) ? topDoorStyleCode : "") +
    (hasTopDoors(hValue, styleCode) ? topDoorHardwareCode : "") +
    (hasMiddleDoors(hValue, styleCode) ? middleDoorStyleCode : "") +
    (hasMiddleDoors(hValue, styleCode) ? middleDoorHardwareCode : "") +
    (hasBottomDoors(hValue, styleCode) ? bottomDoorStyleCode : "") +
    (hasBottomDoors(hValue, styleCode) ? bottomDoorHardwareCode : "") +
    (hasDrawers(hValue, styleCode) ? drawerStyleCode : "") +
    (hasDrawers(hValue, styleCode) ? drawerHardwareCode : "");

  let baseSku = (hValue + styleCode).toUpperCase();
  console.log("Baske SKU: " + baseSku);

   $('.money').text("");
    console.log("start");
    let consoleHandle = handleMap[hValue.toUpperCase() + styleCode.toUpperCase()];
    console.log(consoleHandle);
    $.getJSON(window.Shopify.routes.root + "products/" + consoleHandle + ".js", function (product) {
      console.log(product);
      var newPrice = product.variants[0].price / 100;
      var newID = product.variants[0].id;
      $(".variant-selection").attr("variant", newID);
      $(".money").text("$" + commaFormat(newPrice));
      console.log(newPrice);
      console.log(newID);
      console.log("end");
    }).fail(function() {
      console.log("Error with price lookup");
    });


  console.log("console: " + hValue);
  console.log("style: " + styleCode);
  console.log("finish: " + finishCode);
  console.log("top: " + topCode);
  console.log("base: " + baseCode);
  console.log("top door style: " + (hasTopDoors[styleCode] ? topDoorStyleCode : 0));
  console.log("top door hardware: " + (hasTopDoors[styleCode] ? topDoorHardwareCode : 0));
  console.log("middle door style: " + (hasMiddleDoors[styleCode] ? middleDoorStyleCode : 0));
  console.log("middle door hardware: " + (hasMiddleDoors[styleCode] ? middleDoorHardwareCode : 0));
  console.log("bottom door style: " + (hasBottomDoors[styleCode] ? bottomDoorStyleCode : 0));
  console.log("bottom door hardware: " + (hasBottomDoors[styleCode] ? bottomDoorHardwareCode : 0));
  console.log("drawer style: " + (hasDrawers[styleCode] ? drawerStyleCode : 0));
  console.log("drawer hardware: " + (hasDrawers[styleCode] ? drawerHardwareCode : 0));

  return sku.toUpperCase();
}

function hasTopDoors(hValue, styleCode) {
  let hasTopDoors = { styleCode: false };
  if (hValue === "h3") {
    hasTopDoors = {
      a: true,
      b: false,
      c: true,
      d: true,
      e: false,
      f: true,
      g: true,
      h: true,
      j: false,
    };
  }

  if (hValue === "h2") {
    hasTopDoors = {
      a: false,
      b: true,
      c: true,
      d: false,
      e: true,
      f: true,
      g: false,
      h: true,
      j: true,
    };
  }

  if (hValue === "h1") {
    hasTopDoors = {
      a: false,
      b: true,
      c: true,
      d: false,
      e: true,
      f: false,
      g: true,
    };
  }

  return hasTopDoors[styleCode];
}

function hasMiddleDoors(hValue, styleCode) {
  let hasMiddleDoors = { styleCode: false };
  if (hValue === "h3") {
    hasMiddleDoors = {
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      f: true,
      g: false,
      h: true,
      j: true,
    };
  }

  if (hValue === "h2") {
    hasMiddleDoors = {
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      f: true,
      g: true,
      h: true,
      j: false,
    };
  }

  if (hValue === "h1") {
    hasMiddleDoors = {
      a: false,
      b: false,
      c: true,
      d: false,
      e: true,
      f: true,
      g: false,
    };
  }

  return hasMiddleDoors[styleCode];
}

function hasBottomDoors(hValue, styleCode) {
  let hasBottomDoors = { styleCode: false };
  if (hValue === "h3") {
    hasBottomDoors = {
      a: true,
      b: true,
      c: true,
      d: false,
      e: false,
      f: true,
      g: true,
      h: false,
      j: false,
    };
  }

  if (hValue === "h2") {
    hasBottomDoors = {
      a: false,
      b: false,
      c: true,
      d: true,
      e: true,
      f: true,
      g: true,
      h: false,
      j: true,
    };
  }

  if (hValue === "h1") {
    hasBottomDoors = {
      a: false,
      b: true,
      c: false,
      d: false,
      e: true,
      f: true,
      g: true,
    };
  }

  return hasBottomDoors[styleCode];
}

function hasDrawers(hValue, styleCode) {
  let hasDrawers = { styleCode: false };
  if (hValue === "h3") {
    hasDrawers = {
      a: false,
      b: false,
      c: true,
      d: true,
      e: true,
      f: false,
      g: true,
      h: true,
      j: true,
    };
  }

  if (hValue === "h2") {
    hasDrawers = {
      a: true,
      b: true,
      c: false,
      d: false,
      e: true,
      f: false,
      g: false,
      h: true,
      j: false,
    };
  }

  if (hValue === "h1") {
    hasDrawers = {
      a: true,
      b: false,
      c: true,
      d: true,
      e: false,
      f: false,
      g: false,
    };
  }

  return hasDrawers[styleCode];
}

function commaFormat(nStr) {
  nStr += "";
  x = nStr.split(".");
  x1 = x[0];
  x2 = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  if (x2.length == 1) {
    x2 += "0";
  }
  return x1 + x2;
}
